import { render, staticRenderFns } from "./trainTel.vue?vue&type=template&id=631fb024&scoped=true&"
import script from "./trainTel.vue?vue&type=script&lang=ts&"
export * from "./trainTel.vue?vue&type=script&lang=ts&"
import style0 from "./trainTel.vue?vue&type=style&index=0&id=631fb024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631fb024",
  null
  
)

export default component.exports